var map = {
	"./itemBlack1.webp": 81985,
	"./itemBlack10.webp": 91659,
	"./itemBlack11.webp": 24091,
	"./itemBlack12.webp": 81386,
	"./itemBlack2.webp": 89631,
	"./itemBlack3.webp": 42230,
	"./itemBlack4.webp": 95750,
	"./itemBlack5.webp": 19483,
	"./itemBlack6.webp": 49557,
	"./itemBlack7.webp": 6747,
	"./itemBlack8.webp": 47331,
	"./itemBlack9.webp": 21109
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 26714;